import FormItem from "@/entities/PrizificPageBuilder/components/FormItem";
import { EComponents } from "@/enums/PrizificPageBuilder/EComponents";
import { EShippingAddressFormItem } from "~~/enums/PrizificPageBuilder/EShippingAddressFormItem";

export const shippingStreetFormItem = new FormItem(
    "-",
    "Street form item",
    [],
    "",
    [],
    "Utca, házszám",
    "",
    "Utca, házszám",
    "",
    EShippingAddressFormItem.STREET
);
